import $ from 'jquery';
import "jquery-mousewheel";
import 'malihu-custom-scrollbar-plugin';
import {throttle} from './lib';

let isInit = false,
    animationTime = 1000,
    FIRST_FRAME_WIDTH = 1200,
    FIRST_FRAME_MIN_WIDTH = 320,
    $gallery,
    $wrapperMenu,
    $rightScrollbar,
    $body;

export function open() {
    $gallery = $('.o-gallery');
    $body = $('body');
    $wrapperMenu = $('.wrapper > .b-top-menu');
    $rightScrollbar = $('#mCSB_2_scrollbar_vertical');
    changeIntroGalleryWidth();
    addEventListener();
}

function addEventListener() {
    $('.e-gallerey').click(e => {
        e.preventDefault();
        let gal = isInit ? closeGallery : openGallery;
        isInit = !isInit;
        gal();
    });
}

function openGallery() {
    $body.removeClass('show');
    $rightScrollbar.css({visibility: 'hidden'});
    $gallery.addClass('show');
    $body.css({overflow: 'hidden'});
    $wrapperMenu.css({display: "none"});
    $('.o-gallery .b-top-menu__social').css({display: "block"});

    setTimeout(() => {
        initScrollbar();
        $gallery.addClass('show2');
    }, animationTime);

}

function closeGallery() {
    destroyScrollbar();
    $wrapperMenu.css({display: "block"});
    $rightScrollbar.css({visibility: 'visible'});
    $('.o-gallery .b-top-menu__social').css({display: "none"});
    $body.css({overflow: 'auto'});
    setTimeout(function () {
        $gallery.removeClass('show');
        $gallery.removeClass('show2');
        $body.trigger('closeGallery');
    });
    setTimeout(() => {
        $body.css({overflow: 'auto'});
        $gallery.css({left: 0});
    }, animationTime);
}

function initScrollbar() {
    changeIntroGalleryWidth();
    $body.mCustomScrollbar({
        axis: "x",
        theme: "omgb-theme",
        advanced: {
            updateOnContentResize: false,
            updateOnImageLoad: false,
            autoExpandHorizontalScroll: true

        },
        mouseWheel: {scrollAmount: 500}
    });
    changeGalleryWidth();
}

function destroyScrollbar() {
    let left = $('.mCSB_container').css('left');
    $body.mCustomScrollbar('destroy');
    $gallery.css({left});
}


window.addEventListener('resize', throttle(function (event) {
    changeIntroGalleryWidth();
    changeGalleryWidth();
}, 300));

function changeIntroGalleryWidth() {
    let width = $(window).width();
    width = width > FIRST_FRAME_WIDTH ? FIRST_FRAME_WIDTH : width;
    width = width < FIRST_FRAME_MIN_WIDTH ? FIRST_FRAME_MIN_WIDTH : width;
    $('.intro').css({width});
}

function changeGalleryWidth() {
    let width = 0;
    $gallery.children().each(function (i, el) {
        if(!$(el).hasClass('exception')){
            width += el.offsetWidth;
        }
    });
    $gallery.width(width + 1);
    $body.mCustomScrollbar("update");
}

export default {
    open
}


// WEBPACK FOOTER //
// ./modules/gallery.js